export const enum StepKind {
    Phone = 'phone',
    Code = 'code',
    Legal = 'legal',
}

export type PhoneStep = Readonly<{
    kind: StepKind.Phone;
    phone: string;
    hasAcceptedDataProcessingPolicy: boolean;
    hasAcceptedUserAgreement: boolean;
}>;

export type CodeStep = Readonly<{
    kind: StepKind.Code;
    phone: string;
    hasAcceptedDataProcessingPolicy: boolean;
    hasAcceptedUserAgreement: boolean;
    lifetime: number;
    resendDelay: number;
}>;

export type LegalStep = Readonly<{ kind: StepKind.Legal }>;

export type Step = PhoneStep | CodeStep | LegalStep;
